import styled from 'styled-components'
import colors from '../../../theming/variables/colors'

export const Toggler = styled.div`
  align-items: center;
  background-color: ${colors.white1};
  border-radius: 2.5rem;
  color: ${colors.gray2};
  cursor: pointer;
  display: flex;
  font-size: 1.4rem;
  height: 2.8rem;
  width: 2.8rem;
  justify-content: center;
  position: absolute;
  right: -1.4rem;
  top: 2rem;
  transition: color 0.25s;
  border: 0.1rem solid ${colors.gray2};

  &:hover {
    color: ${colors.gray2};
    transition: color 0.25s;
  }
`
